/**
 * Dates, everywhere, as MM/DD/YYYY.
 *
 * Not toLocaleDateString: that follows the reader's browser locale,
 * so the same notice reads 09/01 on one screen and 01/09 on another.
 * A receipt people rely on months later has to be unambiguous, so the
 * format is fixed rather than inherited.
 */
export const fmtDate = (iso?: string | null): string => {
  if (!iso) return '--';

  // A calendar date arrives as 2026-09-01T00:00:00.000Z and carries
  // no timezone. Reading local parts would shift it a day west of
  // UTC, so the text is used as written.
  const plain = String(iso).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (plain) return `${plain[2]}/${plain[3]}/${plain[1]}`;

  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '--';

  const p = (n: number) => String(n).padStart(2, '0');
  return `${p(d.getMonth() + 1)}/${p(d.getDate())}/${d.getFullYear()}`;
};

/** A timestamp: the same date, then a 12-hour clock. */
export const fmtDateTime = (iso?: string | null): string => {
  if (!iso) return '--';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '--';

  const h = d.getHours();
  const hour = h % 12 === 0 ? 12 : h % 12;
  const min = String(d.getMinutes()).padStart(2, '0');

  return `${fmtDate(iso)} ${hour}:${min} ${h < 12 ? 'AM' : 'PM'}`;
};

/** Just the clock, for a message in today's conversation. */
export const fmtTime = (iso?: string | null): string => {
  if (!iso) return '--';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '--';

  const h = d.getHours();
  const hour = h % 12 === 0 ? 12 : h % 12;
  const min = String(d.getMinutes()).padStart(2, '0');

  return `${hour}:${min} ${h < 12 ? 'AM' : 'PM'}`;
};
